var render, staticRenderFns
import script from "./Common.vue?vue&type=script&lang=js"
export * from "./Common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47609d1c')) {
      api.createRecord('47609d1c', component.options)
    } else {
      api.reload('47609d1c', component.options)
    }
    
  }
}
component.options.__file = "src/components/basic/Common.vue"
export default component.exports